import { useState } from "react";
import { apiDelete } from "../../../api/fetch";
import { getReservationKeyFromPath } from "../../../components/Utils";
import { endpoints } from "../../../utils/Constants";
import useModal from "../../../hooks/useModal";

interface UseReservationModalsParams {
  playUrl: string;
  onCloseGenericError?: () => void;
}

export function useReservationModals({
  playUrl,
  onCloseGenericError,
}: UseReservationModalsParams) {
  const [expirationModalOpen, setExpirationModalOpen] = useState(false);

  const {
    isOpen: isPaymentModalOpen,
    openModal: openPaymentModal,
    closeModal: closePaymentModal,
  } = useModal(false, { disableScrollLock: true });
  const [paymentModalKey, setPaymentModalKey] = useState(0);

  const {
    isOpen: isOrderSummaryOpen,
    openModal: openOrderSummary,
    closeModal: closeOrderSummary,
  } = useModal(false);

  const {
    isOpen: isGenericErrorModalOpen,
    openModal: openGenericErrorModal,
    closeModal: closeGenericErrorModal,
  } = useModal(false, { disableScrollLock: true });

  const handleCloseExpirationModal = () => {
    const requestKey = getReservationKeyFromPath();
    if (requestKey) {
      apiDelete(endpoints.reservation.getReservation(requestKey), {
        keepalive: true,
      }).catch(() => {});
    }
    window.location.href = playUrl || "/";
  };

  const handleCloseGenericErrorModal = () => {
    closeGenericErrorModal();
    onCloseGenericError?.();
  };

  return {
    expirationModalOpen,
    setExpirationModalOpen,
    handleCloseExpirationModal,
    isPaymentModalOpen,
    openPaymentModal,
    closePaymentModal,
    paymentModalKey,
    setPaymentModalKey,
    isOrderSummaryOpen,
    openOrderSummary,
    closeOrderSummary,
    isGenericErrorModalOpen,
    openGenericErrorModal,
    closeGenericErrorModal,
    handleCloseGenericErrorModal,
  };
}
